import { useGlobalState, useStatsigLayer } from '@/hooks';
import { useMyParcelsContext } from '@/modules/pmt/context';

export const useESDefaultBannerCopy = () => {
  const { isLoggedIn } = useGlobalState();
  const { notificationTranslation } = useMyParcelsContext();
  const { getEnglishOnlyText: getAnonymousEnglishOnlyText, isReady: isAnonymousReady } =
    useStatsigLayer('track_my_parcel_copy_layer');
  const { getEnglishOnlyText: getSignedInEnglishOnlyText, isReady: isSignedInReady } = useStatsigLayer(
    'track_my_parcel_signed_in_layer',
  );

  const fallback = {
    mainTextDesktop: notificationTranslation.emailSyncDesktopMainText ?? '',
    mainTextMobile: notificationTranslation.emailSyncMobileMainText ?? '',
    buttonText: notificationTranslation.emailSyncButtonText ?? '',
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const getEnglishOnlyText = isLoggedIn ? getSignedInEnglishOnlyText : getAnonymousEnglishOnlyText;

  return {
    mainTextDesktop: getEnglishOnlyText('email_sync_main_text_desktop', fallback.mainTextDesktop),
    mainTextMobile: getEnglishOnlyText('email_sync_main_text_mobile', fallback.mainTextMobile),
    buttonText: getEnglishOnlyText('email_sync_button_text', fallback.buttonText),
  };
};
